import { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useGetIdentity, useRedirect } from 'react-admin';
import { MemberSummary } from '@wwf/sdk';

export const OrganizationList = () => {
    const { identity, isPending } = useGetIdentity();
    const redirect = useRedirect();

    useEffect(() => {
        if (isPending) return;
        const profile = identity?.profile as MemberSummary | undefined;
        const orgId = profile?.organizationId;
        if (orgId) {
            redirect('show', 'organization', orgId);
        }
    }, [identity, isPending, redirect]);

    if (isPending) {
        return (
            <Box display="flex" justifyContent="center" py={6}>
                <CircularProgress />
            </Box>
        );
    }

    const profile = identity?.profile as MemberSummary | undefined;
    if (!profile?.organizationId) {
        return (
            <Box p={2}>
                <Typography color="text.secondary">
                    No organization is linked to your account.
                </Typography>
            </Box>
        );
    }

    return (
        <Box display="flex" justifyContent="center" py={6}>
            <CircularProgress />
        </Box>
    );
};
